import { forwardRef, type Ref, type SVGProps } from "react";
const IconPointerUpFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m29.89 28.55-13-26a1 1 0 0 0-1.78 0l-13 26A1 1 0 0 0 3 30h26a1 1 0 0 0 .89-1.45" />
  </svg>
);
const ForwardRef = forwardRef(IconPointerUpFilledSVG);
ForwardRef.displayName = "IconPointerUpFilled";
export { ForwardRef as IconPointerUpFilled };
